import './ThankYouSlide.css';

const rhythmBars = [24, 46, 72, 96, 118, 96, 72, 46, 24];

export default function ThankYouSlide() {
  return (
    <section className="slide-content thankyou-hero-slide">
      <div className="thankyou-hero-shell">
        <div className="thankyou-hero-grid" aria-hidden="true" />

        <div className="thankyou-hero-rings" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </div>

        <div className="thankyou-hero-particles" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>

        <svg className="thankyou-hero-wave thankyou-hero-wave-left" viewBox="0 0 520 140" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 70 C50 70 60 28 100 70 S170 112 210 70 S280 28 320 70 S390 112 430 70 S480 48 520 70" />
        </svg>

        <svg className="thankyou-hero-wave thankyou-hero-wave-right" viewBox="0 0 520 140" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 70 C50 70 60 28 100 70 S170 112 210 70 S280 28 320 70 S390 112 430 70 S480 48 520 70" />
        </svg>

        <div className="thankyou-hero-center reveal-stack">
          <div className="thankyou-hero-badge thankyou-hero-badge--logo">
            <img src="/assets/logo-beige.svg" alt="Touch of Health Rehabilitation Center" />
          </div>

          <div className="thankyou-hero-kicker">
            <span />
            <small>Final Note</small>
            <span />
          </div>

          <h2>Thank You</h2>

          <div className="thankyou-hero-eq thankyou-hero-eq-inline" aria-hidden="true">
            {rhythmBars.map((height, index) => (
              <i
                key={`inline-${index}`}
                style={{ '--bar-height': `${Math.max(18, height - 10)}px`, '--bar-delay': `${index * -0.11 - 0.4}s` }}
              />
            ))}
          </div>

        </div>

        <div className="thankyou-hero-footer">
          <span>Hearing Care</span>
          <i />
          <span>Community Screening</span>
          <i />
          <span>Regional Reach</span>
          <i />
          <b>End of Presentation</b>
        </div>
      </div>
    </section>
  );
}
